
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video-production/educational-explainer-video",
      function () {
        return require("private-next-pages/video-production/educational-explainer-video/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video-production/educational-explainer-video"])
      });
    }
  